import { render, staticRenderFns } from "./EditShelf.vue?vue&type=template&id=73f496b6&scoped=true&"
import script from "./EditShelf.vue?vue&type=script&lang=js&"
export * from "./EditShelf.vue?vue&type=script&lang=js&"
import style0 from "./EditShelf.vue?vue&type=style&index=0&id=73f496b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f496b6",
  null
  
)

export default component.exports